import React, { useEffect, useState } from 'react'
import { useSingleMinigrid } from '../../../hook'
import Button from '../../../../../common/components/atom/Button/Button'
import { BinIcon } from '../../../../../common/assets/icons'
import { useNavigate } from 'react-router-dom'
import ConfirmationModal from '../../../../../common/components/atom/ConfirmationModal/ConfirmationModal'
import { PermissionTooltip, useCapability } from '../../../../rbac'


export default function DeleteMinigridPresenter({ backTo}:{backTo?: string}) {
    const {singleMinigridQuery:{data}, deleteMinigrid:{isLoading, isSuccess, mutate: deleteMinigrid}} = useSingleMinigrid()

    const [isModalOpen, setModalOpen] = useState(false)
    // RBAC : suppression d'un minigrid = minigrid.delete (admin).
    const canDelete = useCapability('minigrid.delete')
    const naviagte = useNavigate()
    useEffect(() => {
        if(isSuccess && backTo){

        naviagte(backTo ? backTo : '/main/minigrid')
        }},[isSuccess]) // eslint-disable-line

    if (!data){
      return <></>
    }
    const handleDelete = () => {
      deleteMinigrid({})

    }

    if (isLoading) {
      return <> ... </>
    }


  return (
    <>
    <PermissionTooltip allowed={canDelete}>
    <Button
    label="Supprimer"
    IconComponentLeft={() => <BinIcon />}
    onClick={() =>{ if (canDelete) setModalOpen(true)}}
    disabled={!canDelete}
    variant={"tercery"}/>
    </PermissionTooltip>

    <ConfirmationModal
        isOpen={isModalOpen && canDelete}
        type="danger"
        title="Attention"
        message={`Voulez-vous vraiment supprimer le minigrid ${data.minigrid_name}?`}
        confirmText="Supprimer"
        cancelText="Annuler"
        onConfirm={handleDelete}
        onCancel={() => setModalOpen(false)}
    />
    </>

  )
}
